import { notifications } from '@mantine/notifications';

export interface UploadedFile {
  path: string;
  originalName: string;
}

export async function uploadFile(file: File): Promise<UploadedFile | null> {
  const formData = new FormData();
  formData.append('file', file);
  const response = await fetch('/api/admin/upload', {
    method: 'POST',
    body: formData,
    credentials: 'include',
  });
  if (!response.ok) {
    const failure = (await response.json().catch(() => null)) as { error?: string } | null;
    const fallback = response.status === 413 ? 'File is too large' : 'Upload failed';
    notifications.show({ color: 'red', message: `${file.name}: ${failure?.error ?? fallback}` });
    return null;
  }
  const result = (await response.json()) as { path: string };
  return { path: result.path, originalName: file.name };
}
